import React from 'react';
import ErrorPage from '../../pages/ErrorPage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true , error};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }

  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  handleHide = () => {
    this.resetError();
  };

  render() {
    return (
      <>
        {this.props.children}
        {/* ErrorPage only shows for 500 errors, so React component errors won't display it */}
      </>
    );
  }
}

export default ErrorBoundary;

